import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

export function fetchMediaList(params) {
  return request({
    url: `${v2Host}/creative/delivery/media`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function fetchPlayableList(params) {
  return request({
    url: `${v2Host}/creative/delivery/playable`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function fetchDcoPlList(params) {
  return request({
    url: `${v2Host}/creative/delivery/dco`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

/**
 * fetchDeliveryCreatives
 * @param {{group_id: number}} params
 */
export function fetchDeliveryCreatives(params) {
  return request({
    url: `${v2Host}/creative/delivery/creatives`,
    method: 'get',
    params: params,
  })
}

/**
 * fetchDeliveryGroupChannels
 * @param {{group_id: number}} params
 */
// eslint-disable-next-line camelcase
export function fetchDeliveryGroupChannels({ group_id }) {
  return request({
    url: `${v2Host}/creative/delivery/group-channels`,
    method: 'get',
    params: {
      group_id,
    },
  })
}

export function getDownloadStatus({ group_id }) {
  return request({
    url: `${v2Host}/creative/delivery/download-check`,
    method: 'get',
    params: {
      group_id,
    },
  })
}

export function delAccount({ id }) {
  return request({
    url: `${v2Host}/creative/push/del-account`,
    method: 'post',
    data: {
      id,
    },
  })
}

export function downloadDefaultVersion(params) {
  return request({
    url: `${v2Host}/creative/delivery/download`,
    method: 'get',
    params,
  })
}
